import { config } from '@services/config';
import { IndicationSearchRequestQuery, IndicationSearchResponse } from '@lio/api-types';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { indicationQueryKey } from './keys';

export const useSearchIndication = (params: IndicationSearchRequestQuery, enabled: boolean = true) => {
  const query = new URLSearchParams();
  const { sort, pageLimit, pageOffset, searchText } = params;

  if (sort) query.append('sort', sort);
  if (pageLimit) query.append('pageLimit', pageLimit.toString());
  if (pageOffset) query.append('pageOffset', pageOffset.toString());
  if (searchText) query.append('searchText', searchText);

  const queryParams = query.toString();

  const client = useClient();

  return useQuery<IndicationSearchResponse, Error>({
    queryKey: indicationQueryKey.searchWithParams(params),
    queryFn: () => client.get(`indication?${queryParams}`).json<IndicationSearchResponse>(),
    enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    ...config,
  });
};
